import classNames from "classnames";
import { useAuth } from "../contexts/AuthContext";
import AuthBar from "./auth-bar";
import DesktopNav from "./desktop-nav";
import ChangePasswordDialog from "./dialogs/change-password-dialog";
import ConfirmAccountDialog from "./dialogs/confirm-account-dialog";
import ForgotPasswordDialog from "./dialogs/forgot-password-dialog";
import LoginDialog from "./dialogs/login-dialog";
import MobileNav from "./mobile-nav";

export default function Navbar() {
  const { isLoggedIn } = useAuth();

  return (
    <div className={isLoggedIn ? "mb-10" : ""}>
      {isLoggedIn && <AuthBar />}
      <div
        className={classNames(
          "bg-white text-primary-blue tracking-[0.07rem] fixed h-24 w-full z-[80]",
          { "mt-10": isLoggedIn }
        )}
      >
        <MobileNav />
        <DesktopNav />
        <LoginDialog />
        <ConfirmAccountDialog />
        <ForgotPasswordDialog />
        <ChangePasswordDialog />
      </div>
    </div>
  );
}
